<template>
  <!--  h-offset v-offset blur spread color |inset|initial|inherit;-->
  <div class="form-group">
    <label class="custom-label">{{ this.labelDesc }}</label>
    <div class="form" style="width: 100%">

      <label style="width: 100%">
        {{$t('ct-shadow-h')}}
        <input type="range" :min="minH" :max="max" class="custom-range" v-model="h" @change="changeValue"
               @keyup="changeValue">
      </label>
      <label style="width: 100%">
        {{$t('ct-shadow-v')}}
        <input type="range" :min="minH" :max="max" class="custom-range" v-model="v" @change="changeValue"
               @keyup="changeValue">
      </label>
      <label style="width: 100%">
        {{$t('ct-shadow-b')}}
        <input type="range" :min="min" :max="max" class="custom-range" v-model="b" @change="changeValue"
               @keyup="changeValue">
      </label>
      <label style="width: 100%">
        {{$t('ct-shadow-s')}}
        <input type="range" :min="min" :max="max" class="custom-range" v-model="s" @change="changeValue"
               @keyup="changeValue">
      </label>
      <label style="width: 100%">
        {{$t('ct-shadow-color')}}
        <!--        <input type="color" class="custom-input form-control " v-model="c" @change="changeValue" @keyup="changeValue">-->
        <color-picker-component ref="colorPicker"></color-picker-component>
      </label>
      <label style="width: 100%" v-show="this.inset">
        <input type="checkbox" v-model="i" class="custom-checkbox" @change="changeValue" @keyup="changeValue"
               @toggle="changeValue">
        {{$t('ct-shadow-inset')}}
      </label>
	  <label class="w-100 text-center">
        <button class="btn btn-default btn-sm" @click="resetValues()">{{ $t('ct-clean') }}</button>
      </label>
    </div>
  </div>

</template>

<script>

	import ColorPickerComponent from "./Abstract/ColorPicker";

	export default {
		name: 'BoxShadowComponent',
		components: {ColorPickerComponent},
		data() {
			return {
				element: null,
				h: '0',
				v: '0',
				b: '0',
				s: '0',
				colorValue: '#000000',
				i: false,
				labelDesc: 'shadow',
				callback: null,
				minH: -50,
				min: 0,
				max: 100,
				inset: true,
			}
		},
		methods: {
			changeValue() {
			  let response = {
          h: this.h,
          v: this.v,
          b: this.b,
          s: this.s,
          color: this.colorValue,
          inset: this.i
        }
				this.callback(response);
			},
			resetValues() {
				this.h = '0';
				this.v = '0';
				this.b = '0';
				this.s = '0';
				this.changeValue();
			},
			setValues(obj) {
				let vm = this;

				if (typeof obj.defaultValue === 'undefined') {
					obj.defaultValue = '0 0 0 0 #000000 initial';
				}

				let value = obj.defaultValue.split(' ');

				this.inset = typeof obj.inset != 'undefined' ? obj.inset : true;

				this.h = parseInt(value[0]);
				this.v = parseInt(value[1]);
				this.b = parseInt(value[2]);
				this.s = parseInt(value[3]);
				this.colorValue = value[4];
				this.i = value.length === 6 && value[5] == 'inset';

				this.min = parseInt(obj.min);
				this.max = parseInt(obj.max);
				this.element = obj.element;
				this.labelDesc = obj.labelDesc ? this.$t(`ct-${obj.labelDesc}`) : this.$t(`ct-box-shadow`);
				this.callback = obj.callback;


				let newObj = Object.assign({}, obj);
				newObj.defaultValue = value[4];
				newObj.callback = (value) => {
					vm.colorValue = value;
					vm.changeValue()
				};
				this.$refs.colorPicker.setValues(newObj);

			}
		},
	}

</script>

<style scoped lang="scss">
  .form-group {
    overflow: hidden;
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/resource_components/Shadow.vue